import React from 'react';
import "./testimonials.css";
import Image1 from "../../assets/maycon.jpg";
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { useLanguage } from '../../context/LanguageContext';

const createData = (translations) => [
  {
    id: 1,
    image: Image1,
    title: "Maycon Queiros",
    subtitle: translations.testimonialsSubtitle,
    comment: translations.testimonialsComment,
  },
];

const Testimonials = () => {
  
    const { translations } = useLanguage();
  
    const data = createData(translations);

  return (
    <section className="testimonials container section" id="testimonials">
      <h2 className="section__title">{translations.testimonialsTitle}</h2>

      <Swiper className="testimonials__container grid"
      modules={[Pagination]}
      spaceBetween={30}
      slidesPerView={1}
      loop={true}
      grabCursor={true}
      pagination={{ clickable: true }}
      >
        {data.map(({id, image, title, subtitle, comment}) => {
          return (
            <SwiperSlide className="testimonials__item" key={id}>
              <div className="thumb">
                <img src={image} alt="" />
              </div>
              <h3 className='testimonials__title'>{title}</h3>
              <span className='subtitle'>{subtitle}</span>
              <div className="comment">{comment}</div>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </section>
  )
}

export default Testimonials